/* eslint-disable import/no-cycle */
import { sleepUtils } from '../index-utils';

export function sleep(ms) {
  // return new Promise(resolve => setTimeout(resolve, ms));
  return sleepUtils(ms);
}
